import { createSelector, keyBy } from '../dependencies';

export const menusSelector = state => state.menus.data;
export const triedToFetchSelector = state => state.menus.triedToFetch;
export const restaurantIdFromPropsSelector = (_, { restaurantId }) => restaurantId;
export const fetchingMenusIdsSelector = state => state.menus.fetchingMenusIds;

export const menuIsFetchingSelector = createSelector(
    fetchingMenusIdsSelector,
    restaurantIdFromPropsSelector,
    (fetchingMenusIds, restaurantId) => {
        return fetchingMenusIds.indexOf(restaurantId) > -1;
    },
);

export const menusKeyedByRestaurantIdSelector = createSelector(
    menusSelector,
    menus => keyBy(menus, 'restaurantId'),
);
